import moment from "moment";
import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { BsFilePdf, BsThreeDots } from "react-icons/bs";
import { avatar } from "../../../../assets";
import OverviewReport from "../../Overview/section/OverviewReport";
import { renderAttachments, renderMessage, renderReply } from "./commonMessage";

const LeftSideMessage = ({
  data,
  setIsReplay,
  setSelectReplyData,
  highlightMsg,
  handleViewProfile = () => {},
  scrollToMessage = () => {},
}) => {
  const [reportModal, setReportModal] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  //----------handle-report-------------
  const handleReport = (data) => {
    setSelectedData(data);
    setReportModal(true);
  };

  //----------handle-reply-------------
  const handleReply = (data) => {
    setSelectReplyData(data);
    setIsReplay(true);
  };

  return (
    <div className="msg-item" key={data._id}>
      <div
        // className="message-sender reply_on_msg"
        className={`message-sender reply_on_msg  ${
          highlightMsg ? "highlight-message" : ""
        }`}
      >
        <div className="msg-avatar">
          <img
            className=""
            src={data?._sender?.profilePicture || avatar}
            alt="Avatar"
          />
        </div>
        <div className="msg-content reply-content">
          <div className="msg-header">
            <div className="title">
              <span className="msg-name">{data?._sender?.fullName}</span>

              <span className="msg-time">
                {moment(data?.createdAt).fromNow()}
              </span>
            </div>

            <div className="three-dotss">
              <Dropdown className="custom_dropdown">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <BsThreeDots />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleReport(data)}>
                    Report
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleReply(data)}>
                    Reply
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          {renderReply(data, scrollToMessage)}

          <div className="msg-body">
            {renderMessage(data)}
            {renderAttachments(data, handleViewProfile)}
          </div>
        </div>

        {/* ---------report--------------------- */}
        <OverviewReport
          show={reportModal}
          close={() => setReportModal(false)}
          selectedData={null}
          id={selectedData?._id}
          pageName="Message"
          type="MESSAGE"
        />
      </div>
    </div>
  );
};

export default LeftSideMessage;
